export const links = [
    { name: "About", to: "/" },
    { name: "Our work", to: "/work" },
    { name: "Services", to: "/services" },
    { name: "Sensors", to: "/sensors" },
    { name: "ROSIE", to: "/rosie" },
    { name: "Contact", to: "/contact" },
];
